"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSeries = exports.getSeriesItemData = void 0;
var tslib_1 = require("tslib");
var sdk_ui_vis_commons_1 = require("@gooddata/sdk-ui-vis-commons");
var common_1 = require("../_util/common");
var chartCapabilities_1 = require("./chartCapabilities");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var heatmapChartSeries_1 = require("../heatmap/heatmapChartSeries");
var scatterPlotSeries_1 = require("../scatterPlot/scatterPlotSeries");
var bubbleChartSeries_1 = require("../bubbleChart/bubbleChartSeries");
var treemapChartSeries_1 = require("../treemap/treemapChartSeries");
var bulletChartSeries_1 = require("../bulletChart/bulletChartSeries");
function getSeriesItemData(seriesItem, seriesIndex, measureGroup, viewByAttribute, stackByAttribute, type, colorStrategy, emptyHeaderTitle) {
    return seriesItem.map(function (pointValue, pointIndex) {
        // by default seriesIndex corresponds to measureGroup label index
        var measureIndex = seriesIndex;
        // by default pointIndex corresponds to viewBy label index
        var viewByIndex = pointIndex;
        // drillContext can have 1 to 3 items
        // viewBy attribute label, stackby label if available
        // last drillContextItem is always current serie measure
        if (stackByAttribute) {
            // pointIndex corresponds to viewBy attribute label (if available)
            viewByIndex = pointIndex;
            // stack bar chart has always just one measure
            measureIndex = 0;
        }
        else if (common_1.isOneOfTypes(type, chartCapabilities_1.multiMeasuresAlternatingTypes) && !viewByAttribute) {
            measureIndex = pointIndex;
        }
        var valueProp = {
            y: common_1.parseValue(pointValue),
        };
        if (common_1.isTreemap(type)) {
            valueProp = {
                value: common_1.parseValue(pointValue),
            };
        }
        var pointData = Object.assign(tslib_1.__assign(tslib_1.__assign({}, valueProp), { format: common_1.unwrap(measureGroup.items[measureIndex]).format }), pointValue === null
            ? {
                marker: {
                    enabled: false,
                },
            }
            : {});
        if (stackByAttribute) {
            // if there is a stackBy attribute, then seriesIndex corresponds to stackBy label index
            pointData.name = sdk_ui_vis_commons_1.valueWithEmptyHandling(sdk_ui_1.getMappingHeaderFormattedName(stackByAttribute.items[seriesIndex]), emptyHeaderTitle);
        }
        else if (common_1.isOneOfTypes(type, chartCapabilities_1.multiMeasuresAlternatingTypes) && viewByAttribute) {
            pointData.name = sdk_ui_vis_commons_1.valueWithEmptyHandling(sdk_ui_1.getMappingHeaderFormattedName(viewByAttribute.items[viewByIndex]), emptyHeaderTitle);
        }
        else {
            pointData.name = sdk_ui_vis_commons_1.valueWithEmptyHandling(common_1.unwrap(measureGroup.items[measureIndex]).name, emptyHeaderTitle);
        }
        if (common_1.isOneOfTypes(type, chartCapabilities_1.multiMeasuresAlternatingTypes)) {
            pointData.color = colorStrategy.getColorByIndex(pointIndex);
            // Pie and Treemap charts use pointData viewByIndex as legendIndex if available
            // instead of seriesItem legendIndex
            pointData.legendIndex = viewByAttribute ? viewByIndex : pointIndex;
        }
        return pointData;
    });
}
exports.getSeriesItemData = getSeriesItemData;
function getDefaultSeries(dv, measureGroup, viewByAttribute, stackByAttribute, type, colorStrategy, emptyHeaderTitle) {
    return dv
        .rawData()
        .twoDimData()
        .map(function (seriesItem, seriesIndex) {
        var seriesItemData = getSeriesItemData(seriesItem, seriesIndex, measureGroup, viewByAttribute, stackByAttribute, type, colorStrategy, emptyHeaderTitle);
        var seriesItemConfig = {
            color: colorStrategy.getColorByIndex(seriesIndex),
            legendIndex: seriesIndex,
            data: seriesItemData,
            seriesIndex: seriesIndex,
        };
        if (stackByAttribute) {
            // if stackBy attribute is available, seriesName is a stackBy attribute value of index seriesIndex
            // this is a limitation of highcharts and a reason why you can not have multi-measure stacked charts
            seriesItemConfig.name = sdk_ui_vis_commons_1.valueWithEmptyHandling(sdk_ui_1.getMappingHeaderFormattedName(stackByAttribute.items[seriesIndex]), emptyHeaderTitle);
        }
        else if (common_1.isOneOfTypes(type, chartCapabilities_1.multiMeasuresAlternatingTypes) && !viewByAttribute) {
            // Pie charts with measures only have a single series which name would is ambiguous
            seriesItemConfig.name = measureGroup.items
                .map(function (wrappedMeasure) {
                return sdk_ui_vis_commons_1.valueWithEmptyHandling(common_1.unwrap(wrappedMeasure).name, emptyHeaderTitle);
            })
                .join(", ");
        }
        else {
            // otherwise seriesName is a measure name of index seriesIndex
            seriesItemConfig.name = sdk_ui_vis_commons_1.valueWithEmptyHandling(measureGroup.items[seriesIndex].measureHeaderItem.name, emptyHeaderTitle);
        }
        var turboThresholdProp = common_1.isTreemap(type) ? { turboThreshold: 0 } : {};
        return tslib_1.__assign(tslib_1.__assign({}, seriesItemConfig), turboThresholdProp);
    });
}
function getSeries(dv, measureGroup, viewByAttribute, stackByAttribute, type, colorStrategy, emptyHeaderTitle, theme) {
    if (common_1.isHeatmap(type)) {
        return heatmapChartSeries_1.getHeatmapSeries(dv, measureGroup, theme);
    }
    else if (common_1.isScatterPlot(type)) {
        return scatterPlotSeries_1.getScatterPlotSeries(dv, stackByAttribute, colorStrategy, emptyHeaderTitle);
    }
    else if (common_1.isBubbleChart(type)) {
        return bubbleChartSeries_1.getBubbleChartSeries(dv, measureGroup, stackByAttribute, colorStrategy, emptyHeaderTitle);
    }
    else if (common_1.isTreemap(type) && stackByAttribute) {
        return treemapChartSeries_1.getTreemapStackedSeries(dv, measureGroup, viewByAttribute, stackByAttribute, colorStrategy, emptyHeaderTitle);
    }
    else if (common_1.isBulletChart(type)) {
        return bulletChartSeries_1.getBulletChartSeries(dv, measureGroup, colorStrategy);
    }
    return getDefaultSeries(dv, measureGroup, viewByAttribute, stackByAttribute, type, colorStrategy, emptyHeaderTitle);
}
exports.getSeries = getSeries;
//# sourceMappingURL=chartSeries.js.map